export const CREATE_PAYMENT = 'CREATE_PAYMENT'
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT'
export const DELETE_PAYMENT = 'DELETE_PAYMENT'